var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 180,
    viewBox: "0 0 176 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150 99.4066H112.8L100.4 117.254H75.6L63.2 99.4066H26",
    stroke: "#E4D5C9",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.39 58.4168L26 99.4066V135.102C26 138.257 27.3064 141.284 29.6319 143.515C31.9573 145.746 35.1113 147 38.4 147H137.6C140.889 147 144.043 145.746 146.368 143.515C148.694 141.284 150 138.257 150 135.102V99.4066L128.61 58.4168C127.583 56.4344 126.001 54.7662 124.04 53.5996C122.08 52.433 119.819 51.8144 117.512 51.8132H58.488C56.1811 51.8144 53.9202 52.433 51.9597 53.5996C49.9991 54.7662 48.4166 56.4344 47.39 58.4168V58.4168Z",
    stroke: "#E4D5C9",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.001 25L88.001 35.0549",
    stroke: "#E4D5C9",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M110.007 31.2855L102.597 38.3954",
    stroke: "#E4D5C9",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9946 31.2855L73.4043 38.3954",
    stroke: "#E4D5C9",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyQuestion);
export default __webpack_public_path__ + "static/media/EmptyQuestion.21b8f44b339c54a82d55b4b70c13fc63.svg";
export { ForwardRef as ReactComponent };